import React from 'react';
import withIcon from '../utilities/withIcon';

const IconBell = () => {
  return (
    <g>
      <path d="M7.995 0a.75.75 0 0 1 .743.649l.007.102v.785a5.754 5.754 0 0 1 5 5.47l.005.237v2.353l1.188 2.897a.751.751 0 0 1-.506 1.012l-.094.018-.098.006-3.74-.023-.005.156a2.501 2.501 0 0 1-4.99 0l-.005-.184-3.758-.02a.75.75 0 0 1-.72-.951l.033-.093L2.25 9.59V7.243a5.754 5.754 0 0 1 4.994-5.706l.001-.786A.75.75 0 0 1 7.995 0zM7 13.487v.01a1 1 0 0 0 2 .002l-2-.012zM8 2.989l-.206.005a4.252 4.252 0 0 0-4.039 4.043l-.005.206v2.502a.751.751 0 0 1-.027.198l-.032.095-.816 1.923 10.248.06-.817-1.991-.03-.093-.02-.095-.006-.097V7.243a4.252 4.252 0 0 0-4.044-4.249L8 2.99z" />
    </g>
  );
};

export default withIcon(IconBell);
